



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { pics } from "@/config/host.config";
import { downloadImage } from "@/services/getImage";

import StandartModal from "@/components/app/standart-modal.vue";

import type { ISection } from "@/@types/instructions/section";

@Component({ components: { StandartModal } })
class InstructionsFilesModal extends Vue {
  @Prop({ type: Object, default: null }) active_section!: ISection | null;

  acceptFormats = ".png,.jpg,.jpeg,.gif,.webp,.pdf";
  uploadLang = "";

  $refs!: {
    fileInput: HTMLInputElement;
  };

  get section(): ISection | null {
    return this.active_section;
  }

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  get canEdit(): boolean {
    return this.$getRight("updateSections");
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  pickFile(lang: string): void {
    this.uploadLang = lang;
    this.$refs.fileInput.value = "";
    this.$refs.fileInput.click();
  }

  async onFileChange(e: Event): Promise<void> {
    const input = e.target as HTMLInputElement;
    const file = input.files ? input.files[0] : null;
    if (!file || !this.section || !this.section._id || !this.uploadLang) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await this.$axios.put(
        pics.sections + "/file/" + this.section._id,
        formData,
        { params: { lang: this.uploadLang } }
      );
      if (res.status === 200) {
        this.onSuccess();
        this.$emit("update");
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  async deleteFile(lang: string): Promise<void> {
    if (!this.section || !this.section._id) return;
    try {
      const res = await this.$axios.delete(pics.sections + "/clear", {
        params: { id: this.section._id, lang },
      });
      if (res.status === 200) {
        this.onSuccess();
        this.$emit("update");
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  mimeByExt(ext: string): string {
    const mimes: Record<string, string> = {
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      gif: "image/gif",
      webp: "image/webp",
      pdf: "application/pdf",
    };
    return mimes[ext] || "application/octet-stream";
  }

  async viewFile(lang: string): Promise<void> {
    const name = this.section?.files[lang];
    const id = this.section?._id;
    if (!name || !id) return;
    try {
      const path = `sections/${id}/${lang}`;
      const blob = await downloadImage(pics.download, name, path);
      const ext = name.split(".").pop() || "";
      const url = URL.createObjectURL(
        new Blob([blob], { type: this.mimeByExt(ext) })
      );
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }
}
export default InstructionsFilesModal;
